import { setRange } from './helpers';

export const setFloorn = setRange('floorn');
